import React, { Fragment } from 'react'
import Container from '../../../atoms/Container'
import AnswersTable from '../../../organisms/answers/AnswersTable'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { useQuery } from 'react-query'
import { PageNavigation } from '../../../organisms/navigation/PageNavigation'
import AnswersFilter from '../../../organisms/answers/AnswersFilter'
import useFilters from '../../../../hooks/useFilters'
import { BoxTable } from '../../../molecules/BoxTable'
import PageHeading from '../../../molecules/PageHeading'
import ExportSelectButton from '../../../organisms/exports/ExportSelectButton'

const fetchForm = id => axios.get(`/admin/v1/forms/${id}.json`).then(a => a.data)

const Answers = () => {
  const { id: formId } = useParams()
  const url = `/formularios/${formId}/exportaciones`
  const {
    onFilter,
    filters,
    initialFilters,
    results: answers
  } = useFilters(`/admin/v1/forms/${formId}/answers.json`, { sort: 'desc' })
  const { data: formData, status: formStatus } = useQuery(['formulario', formId], () => fetchForm(formId))

  if (formStatus !== 'success') return null

  return (
    <Fragment>
      <PageNavigation breadcrumbData={formData} />
      <Container>
        <PageHeading
          title={`Respuestas de ${formData.name}`}
          pageDescription="Revisa todas las respuestas que tu formulario ha recibido."
        />
        <BoxTable
          filters={<AnswersFilter formHasWebhook={formData.has_webhook} hasOfficeHour={formData.has_office_hour} />}
          onFilter={onFilter}
          initialFilters={initialFilters}
          values={answers}
          displayTotal
          displaySort
          displayHeader={false}
          accordionHasBackground={false}
          searchPlaceholder="Buscar por nombre, nro. de documento o código"
          searchClassName="sm:max-w-104"
          asideFilter={
            <ExportSelectButton
              mainExportable={{
                title: 'Exportar respuestas',
                exportable: { type: 'form', id: formId }
              }}
              listExportables={[
                {
                  title: 'Exportar tiempos de atención',
                  exportable: { type: 'processing_time', id: formId }
                }
              ]}
              url={url}
              filters={filters}
            />
          }
        >
          <AnswersTable form={formData} answers={answers.data} formHasCost={answers.form_has_cost} />
        </BoxTable>
      </Container>
    </Fragment>
  )
}

export default Answers
